import { useMemo, useState, useEffect, useRef } from "react";

import {
  InspectionResult,
  InspectionResultSymbol,
  InspectionType,
} from "../enum";
import InspectionForwardingDialog from "./InspectionForwardingDialog";

const InspectionWorkingPositionControl = ({ workingPosition, inspectionType, administrativeAutorities, onInspectionResult, onInspectionEdit }) => {
  const [showForwardTo, setShowForwardTo] = useState(false);
  const [forwardTo, setForwardTo] = useState('');

  const wrapperRef = useRef(null);

  const { shouldBeInspected, currentInspection, periodYear, administrativeAutoritiesOptions } = useMemo(() => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const startDate = workingPosition.start ? new Date(workingPosition.start) : null;
    const endDate = workingPosition.end ? new Date(workingPosition.end) : null;

    const periodFrom = now.getMonth() < 6
        ? new Date(currentYear - 1, 6, 1)  // 1.7. last year
        : new Date(currentYear, 6, 1);      // 1.7. current year

    const periodTo = new Date(periodFrom);
    periodTo.setFullYear(periodTo.getFullYear() + 1);
    periodTo.setDate(periodTo.getDate() - 1);

    const periodYear = inspectionType === InspectionType.ONGOING_STATEMENT ? periodFrom.getFullYear() : undefined;

    let shouldBeInspected = false;
    let inspections = (workingPosition.inspections || [])
        .filter(i => i.type === inspectionType && !i.deleted)
        .sort((a, b) => (new Date(b.inspectionDate) - new Date(a.inspectionDate)));

    switch (inspectionType) {
      case InspectionType.INGOING_STATEMENT:
        shouldBeInspected = !!startDate;
        break;

      case InspectionType.OUTGOING_STATEMENT:
        shouldBeInspected = !!endDate;
        break;

      case InspectionType.ONGOING_STATEMENT:
        shouldBeInspected = !!startDate && startDate.getFullYear() < periodYear && (!endDate || endDate.getFullYear() >= currentYear);

        inspections = inspections.filter(i => {
          const inspectionPeriodYear = i.periodFrom ? new Date(i.periodFrom).getFullYear() : 0;
          return inspectionPeriodYear === periodYear;
        });
        break;

      default:
        shouldBeInspected = false;
    }

    const currentInspection = inspections.length ? inspections[0] : null;
    const administrativeAutoritiesOptions = [...(administrativeAutorities || [])].sort();

    return { shouldBeInspected, currentInspection, periodYear, administrativeAutoritiesOptions };
  }, [workingPosition, inspectionType]);

  const chooseForwardTo = (event) => {
    event.stopPropagation();
    setShowForwardTo(true);
  }

  const cancelChooseForwardTo = (event) => {
    event.stopPropagation();
    setShowForwardTo(false);
  }

  return (
    shouldBeInspected ?
      <div className="cro__inspectionControl minified">
        {currentInspection && (
          <div className={`inspectionControl__state selected ${currentInspection.result.toLowerCase()}`} onClick={(e) => {
            e.stopPropagation();
            onInspectionEdit(currentInspection.id);
          }}>
            { InspectionResultSymbol[currentInspection.result] }
          </div>
        )}
        {!currentInspection && (
          <div className="inspectionControl__selector" ref={wrapperRef}>
            <div className="inspectionControl__state ok" onClick={(e) => {
              onInspectionResult(workingPosition.id, inspectionType, InspectionResult.OK, periodYear, undefined, undefined);
              e.stopPropagation();
            }}>
              {InspectionResultSymbol.OK}
            </div>
            <div className="inspectionControl__state problem" onClick={chooseForwardTo}>
              {InspectionResultSymbol.PROBLEM}
            </div>
          </div>
        )}

        {showForwardTo && administrativeAutorities && administrativeAutorities.length && (
          <InspectionForwardingDialog
            onCancel={cancelChooseForwardTo}
            forwardTo={forwardTo}
            administrativeAutoritiesOptions={administrativeAutoritiesOptions}
            onForward={(result, forwardTo, note) => {
              onInspectionResult(workingPosition.id, inspectionType, result, periodYear, forwardTo, note);
              setShowForwardTo(false);
            }} />
        )}
      </div>
      : ''
  );
}

export default InspectionWorkingPositionControl;